import { useEffect } from 'react';

import styles from './BusinessPlan.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DragDropUpload from '../components/DragDropUpload/DragDropUpload';
import FileStatusSections from '../components/FileStatusSections/FileStatusSections';

const DOCUMENT_TYPE = 'business plan';
const listOfInstructions = [
  'The business you are proposing',
  'How you plan on generating revenue',
  'The size of investment you need',
  'How the funds will be used',
  'Details of your experience in the industry',
];

const BusinessPlan = () => {
  const stateKey = useContextStateKey();
  const { documents } = useGetDocuments(stateKey);

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  useEffect(() => {
    if (documents) {
      const bankStatementDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(bankStatementDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DragDropUpload
        documentType={DOCUMENT_TYPE}
        description="Include information on:"
        listOfInstructions={listOfInstructions}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
      />

      <FileStatusSections files={uploadedFiles} removeFile={removeFile} />
    </div>
  );
};

export default BusinessPlan;
